import { Link } from 'react-router-dom';
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import VisaCalculator from './components/VisaCalculator';

export default function HomePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const services = [
    {
      title: 'Schengen Bölgesi C Tipi Vizeler',
      description: 'Turistik, ticari ve aile ziyareti amaçlı kısa süreli vizeler',
      icon: 'ri-passport-line',
      gradient: 'from-blue-400 to-blue-500',
      image: 'https://public.readdy.ai/ai/img_res/5b04ddb10199c444a0affdb5ceb5a193.jpg',
      link: '/hizmetler/schengen-c-tipi-vizeler',
    },
    {
      title: 'Schengen Bölgesi D Tipi Vizeler',
      description: 'Uzun süreli ve ulusal vize başvuruları',
      icon: 'ri-time-line',
      gradient: 'from-primary to-blue-600',
      image: 'https://readdy.ai/api/search-image?query=Long%20term%20residence%20permit%20card%20and%20national%20visa%20documents%20with%20European%20flag%20on%20modern%20office%20desk%20professional%20immigration%20concept%20clean%20bright%20lighting%20minimal%20white%20background&width=800&height=600&seq=schengen-d-visa-002&orientation=landscape',
      link: '/hizmetler/schengen-d-tipi-vizeler',
    },
    {
      title: 'Amerika Vizesi',
      description: 'B1/B2, öğrenci ve diğer vize türleri',
      icon: 'ri-flight-takeoff-line',
      gradient: 'from-blue-500 to-indigo-500',
      image: 'https://readdy.ai/api/search-image?query=United%20States%20visa%20application%20documents%20with%20American%20passport%20and%20DS-160%20form%20on%20professional%20desk%20USA%20embassy%20interview%20preparation%20bright%20clean%20background%20business%20travel%20concept&width=800&height=600&seq=usa-visa-003&orientation=landscape',
      link: '/hizmetler/amerika-vizesi',
    },
    {
      title: 'İngiltere Vizesi',
      description: 'UK turist, öğrenci ve iş vizesi danışmanlığı',
      icon: 'ri-building-line',
      gradient: 'from-cyan-400 to-blue-500',
      image: 'https://readdy.ai/api/search-image?query=United%20Kingdom%20visa%20application%20with%20British%20passport%20and%20immigration%20documents%20on%20elegant%20office%20desk%20UK%20travel%20permit%20professional%20lighting%20clean%20minimal%20background%20London%20Big%20Ben%20subtle%20background&width=800&height=600&seq=uk-visa-004&orientation=landscape',
      link: '/hizmetler/ingiltere-vizesi',
    },
    {
      title: 'Oturum Kartı Başvuruları',
      description: 'Yurt dışı oturum izni başvuru süreçleri',
      icon: 'ri-home-line',
      gradient: 'from-blue-400 to-cyan-500',
      image: 'https://readdy.ai/api/search-image?query=Residence%20permit%20card%20and%20immigration%20documents%20with%20house%20keys%20on%20modern%20desk%20permanent%20residency%20application%20concept%20bright%20professional%20lighting%20clean%20white%20background%20relocation%20theme&width=800&height=600&seq=residence-permit-005&orientation=landscape',
      link: '/hizmetler/oturum-karti-basvurulari',
    },
    {
      title: 'Göçmenlik ve Aile Birleşimi Süreçleri',
      description: 'Aile birleşimi ve göçmenlik süreçleri',
      icon: 'ri-group-line',
      gradient: 'from-primary to-cyan-500',
      image: 'https://readdy.ai/api/search-image?query=Family%20reunion%20immigration%20documents%20with%20family%20photos%20and%20visa%20papers%20on%20warm%20desk%20setting%20migration%20and%20relocation%20concept%20emotional%20bright%20lighting%20clean%20background%20unity%20theme&width=800&height=600&seq=family-reunion-006&orientation=landscape',
      link: '/hizmetler/gocmenlik-aile-birlesiimi',
    },
    {
      title: 'Kapı Vizeleri',
      description: 'Havalimanında alınan vize işlemleri',
      icon: 'ri-door-open-line',
      gradient: 'from-blue-500 to-primary',
      image: 'https://readdy.ai/api/search-image?query=Airport%20visa%20on%20arrival%20counter%20with%20passport%20control%20documents%20and%20boarding%20pass%20international%20terminal%20bright%20modern%20setting%20clean%20professional%20background%20border%20crossing%20concept&width=800&height=600&seq=visa-on-arrival-007&orientation=landscape',
      link: '/hizmetler/kapi-vizeleri',
    },
    {
      title: 'E-Vizeler',
      description: 'Online vize başvuruları ve takip',
      icon: 'ri-smartphone-line',
      gradient: 'from-cyan-500 to-blue-400',
      image: 'https://readdy.ai/api/search-image?query=Electronic%20visa%20application%20on%20smartphone%20and%20laptop%20screen%20with%20digital%20passport%20online%20e-visa%20system%20modern%20technology%20bright%20clean%20background%20digital%20travel%20authorization%20concept&width=800&height=600&seq=e-visa-008&orientation=landscape',
      link: '/hizmetler/e-vizeler',
    },
    {
      title: 'Özel Danışmanlık Hizmetleri',
      description: 'Kişiye özel vize danışmanlık çözümleri',
      icon: 'ri-user-star-line',
      gradient: 'from-blue-400 to-indigo-500',
      image: 'https://readdy.ai/api/search-image?query=VIP%20visa%20consultation%20service%20with%20professional%20consultant%20and%20client%20meeting%20in%20modern%20office%20premium%20immigration%20advisory%20elegant%20setting%20bright%20lighting%20clean%20background%20personalized%20service%20concept&width=800&height=600&seq=vip-consultation-009&orientation=landscape',
      link: '/hizmetler/ozel-danismanlik',
    },
  ];

  const countries = [
    { name: 'İspanya', flag: '🇪🇸', link: '/ulkeler' },
    { name: 'Fransa', flag: '🇫🇷', link: '/ulkeler' },
    { name: 'Almanya', flag: '🇩🇪', link: '/ulkeler' },
    { name: 'İngiltere', flag: '🇬🇧', link: '/ulkeler' },
    { name: 'Yunanistan', flag: '🇬🇷', link: '/ulkeler' },
    { name: 'Hollanda', flag: '🇳🇱', link: '/ulkeler' },
    { name: 'İtalya', flag: '🇮🇹', link: '/ulkeler' },
    { name: 'Bulgaristan', flag: '🇧🇬', link: '/ulkeler' },
  ];

  const processSteps = [
    {
      number: '1',
      title: 'Ön Değerlendirme',
      description: 'Seyahat amacı ve profil analizi yapılır',
      icon: 'ri-file-list-3-line',
    },
    {
      number: '2',
      title: 'Evrak Planlaması',
      description: 'Gerekli belgeler detaylı şekilde belirlenir',
      icon: 'ri-file-text-line',
    },
    {
      number: '3',
      title: 'Profesyonel Evrak Kontrolü',
      description: 'Eksik veya riskli belgeler önceden tespit edilir',
      icon: 'ri-search-line',
    },
    {
      number: '4',
      title: 'Başvuru ve Randevu Yönetimi',
      description: 'Konsolosluk ve aracı kurum işlemleri yürütülür',
      icon: 'ri-calendar-check-line',
    },
    {
      number: '5',
      title: 'Süreç Takibi',
      description: 'Başvurunuz sonuçlanana kadar bilgilendirme devam eder',
      icon: 'ri-checkbox-circle-line',
    },
  ];

  const faqs = [
    {
      question: 'Vize danışmanları ne kadar ücret alıyor?',
      answer: 'Ücretler vize türüne ve hizmet kapsamına göre değişir.',
    },
    {
      question: 'En kolay vize nereden alınır?',
      answer: 'Kişisel profil ve seyahat geçmişine göre değişiklik gösterir.',
    },
    {
      question: 'Vize için hesapta kaç TL olması lazım?',
      answer: 'Ülkeye ve seyahat süresine göre değişmektedir.',
    },
  ];

  const testimonials = [
    {
      name: 'Ayşe Yılmaz',
      service: 'Schengen Vizesi - İspanya',
      rating: 5,
      comment: 'İzmir Vize Danışmanlık sayesinde İspanya vizemi çok hızlı bir şekilde aldım. Tüm süreç boyunca profesyonel destek aldım. Kesinlikle tavsiye ediyorum!',
    },
    {
      name: 'Mehmet Kaya',
      service: 'Amerika Vizesi',
      rating: 5,
      comment: 'Amerika vize mülakatı için çok endişeliydim. Ekip beni çok iyi hazırladı ve vizemi ilk seferde aldım. %98 başarı oranları gerçekten doğruymuş!',
    },
    {
      name: 'Zeynep Demir',
      service: 'İngiltere Vizesi',
      rating: 5,
      comment: 'Öğrenci vizem için başvurdum. Tüm evrakları eksiksiz hazırladılar ve süreç çok hızlı ilerledi. Konak\'taki ofisleri çok merkezi, ulaşımı kolay. Teşekkürler!',
    },
  ];

  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-lightBlue">
      <Header />

      {/* Image Modal */}
      {isImageModalOpen && (
        <div 
          className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setIsImageModalOpen(false)}
        >
          <button
            onClick={() => setIsImageModalOpen(false)}
            className="absolute top-4 right-4 w-12 h-12 flex items-center justify-center text-white hover:text-gray-300 transition-colors"
            aria-label="Kapat"
          >
            <i className="ri-close-line text-4xl"></i>
          </button>
          <img
            src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/5a37f747b3c0843e41b287ba8918944d.png"
            alt="İzmir Vize Danışmanlık Ofisi"
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-primary/10 via-lightBlue to-white overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <svg className="w-full h-full" viewBox="0 0 1200 800" fill="none">
            <circle cx="200" cy="200" r="150" stroke="currentColor" strokeWidth="2" />
            <circle cx="1000" cy="600" r="200" stroke="currentColor" strokeWidth="2" />
            <path d="M0 400 Q 300 300 600 400 T 1200 400" stroke="currentColor" strokeWidth="2" />
          </svg>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-28">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Left Content */}
            <div className="space-y-4 sm:space-y-6">
              <div className="inline-flex items-center space-x-2 bg-lightBlue px-3 sm:px-4 py-2 rounded-full">
                <i className="ri-award-line text-secondary text-sm sm:text-base"></i>
                <span className="font-body text-xs sm:text-sm font-semibold text-darkBlue">
                  10+ Yıl Deneyim | %98 Başarı Oranı
                </span>
              </div>

              <span className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl xl:text-6xl text-darkBlue leading-tight block">
                İzmir Vize Danışmanlık
              </span>

              <p className="font-body text-sm sm:text-base lg:text-lg text-gray-600 leading-relaxed">
                Yurt dışı seyahat planları, doğru vize süreci yönetilmediğinde zaman kaybına ve maddi zarara dönüşebilir. izmirvizedanismanlik.net, İzmir merkezli profesyonel kadrosu ile vize başvurularınızı en doğru şekilde yönetmeyi hedefler.
              </p>

              <p className="font-body text-sm sm:text-base lg:text-lg text-gray-600 leading-relaxed">
                Yüksek onay oranı, şeffaf hizmet anlayışı, iade garantisi ve profesyonel evrak takibi ile süreci sizin adınıza güvenle yürütür.
              </p>

              <p className="font-body text-sm sm:text-base lg:text-lg text-gray-600 leading-relaxed">
                10 yılı aşkın sektör deneyimimiz sayesinde, farklı ülke ve vize türlerinde başvuru yapan danışanlarımıza doğru yönlendirme sağlıyor, başvuruların eksiksiz ve hatasız ilerlemesini önceliklendiriyoruz.
              </p>

              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <Link
                  to="/iletisim"
                  className="bg-secondary hover:bg-secondary/90 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-body font-semibold text-sm sm:text-base transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center space-x-2 whitespace-nowrap"
                >
                  <span>Hemen Başvur</span>
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <a
                  href="#process"
                  className="bg-white hover:bg-gray-50 text-secondary border-2 border-secondary px-6 sm:px-8 py-3 sm:py-4 rounded-full font-body font-semibold text-sm sm:text-base transition-all duration-300 flex items-center justify-center space-x-2 whitespace-nowrap"
                >
                  <span>Süreç Nasıl İşler?</span>
                  <i className="ri-arrow-down-line"></i>
                </a>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-3 gap-3 sm:gap-4 pt-4 sm:pt-6">
                <div className="bg-white rounded-xl sm:rounded-2xl p-3 sm:p-4 shadow-md">
                  <div className="font-heading font-bold text-xl sm:text-2xl lg:text-3xl text-secondary">2500+</div>
                  <div className="font-body text-xs sm:text-sm text-gray-600">Başarılı Vize</div>
                </div>
                <div className="bg-white rounded-xl sm:rounded-2xl p-3 sm:p-4 shadow-md">
                  <div className="font-heading font-bold text-xl sm:text-2xl lg:text-3xl text-secondary">%98</div>
                  <div className="font-body text-xs sm:text-sm text-gray-600">Başarı Oranı</div>
                </div>
                <div className="bg-white rounded-xl sm:rounded-2xl p-3 sm:p-4 shadow-md">
                  <div className="font-heading font-bold text-xl sm:text-2xl lg:text-3xl text-secondary">50+</div>
                  <div className="font-body text-xs sm:text-sm text-gray-600">Ülke Vizesi</div>
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative">
              <div 
                className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl cursor-pointer group"
                onClick={() => setIsImageModalOpen(true)}
              >
                <img
                  src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/5a37f747b3c0843e41b287ba8918944d.png"
                  alt="İzmir Vize Danışmanlık Ofisi"
                  className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="eager"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-14 h-14 bg-white/90 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-lg">
                    <i className="ri-zoom-in-line text-2xl text-darkBlue"></i>
                  </div>
                </div>
              </div>
              <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6 bg-white rounded-xl sm:rounded-2xl p-3 sm:p-4 shadow-xl">
                {/* Element removed as requested */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl text-darkBlue mb-3 sm:mb-4">
              İzmir Vize Danışmanlık Hizmetlerimiz
            </h2>
            <p className="font-body text-sm sm:text-base lg:text-lg text-gray-600 max-w-2xl mx-auto">
              izmirvizedanismanlik.net olarak bireysel ve kurumsal danışanlarımıza geniş kapsamlı vize danışmanlık hizmetleri sunuyoruz
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-6 sm:mb-8">
            {services.map((service, index) => (
              <Link
                key={index}
                to={service.link}
                className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="h-32 sm:h-36 lg:h-40 overflow-hidden relative">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end justify-center pb-3">
                    <i className={`${service.icon} text-white text-3xl sm:text-4xl`}></i>
                  </div>
                </div>
                <div className="p-3 sm:p-4 space-y-2 sm:space-y-3">
                  <h3 className="font-heading font-bold text-base sm:text-lg lg:text-xl text-darkBlue group-hover:text-secondary transition-colors">
                    {service.title}
                  </h3>
                  <p className="font-body text-xs sm:text-sm text-gray-600">{service.description}</p>
                  <div className="flex items-center text-secondary font-semibold">
                    <span className="font-body text-xs sm:text-sm">Detaylı Bilgi</span>
                    <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="max-w-3xl mx-auto">
            <p className="font-body text-sm sm:text-base text-gray-600 text-center">
              Her başvuru türü, ilgili ülkenin güncel prosedürlerine uygun şekilde ayrı ayrı değerlendirilir ve danışan özelinde planlanır.
            </p>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section id="process" className="py-12 sm:py-16 lg:py-20 bg-gradient-to-b from-lightBlue to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl text-darkBlue mb-3 sm:mb-4">
              İzmir Vize Danışmanlık Süreci Nasıl İşler?
            </h2>
            <p className="font-body text-sm sm:text-base lg:text-lg text-gray-600 max-w-2xl mx-auto">
              Vize danışmanlık sürecimiz net, şeffaf ve adım adım ilerler
            </p>
          </div>

          <div className="max-w-4xl mx-auto space-y-6 mb-8">
            {processSteps.map((step, index) => (
              <div key={index} className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-secondary rounded-full flex items-center justify-center text-white font-heading font-bold text-xl">
                    {step.number}
                  </div>
                  {index < processSteps.length - 1 && (
                    <div className="w-0.5 h-16 bg-secondary/30 mx-auto mt-2"></div>
                  )}
                </div>
                <div className="bg-white rounded-xl p-6 shadow-md flex-1 hover:shadow-lg transition-shadow border-2 border-gray-100">
                  <div className="flex items-start justify-between mb-2">
                    <h4 className="font-heading font-bold text-lg text-darkBlue">{step.title}</h4>
                    <i className={`${step.icon} text-secondary text-xl`}></i>
                  </div>
                  <p className="font-body text-gray-600">{step.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="max-w-3xl mx-auto text-center">
            <p className="font-body text-gray-600">
              Bu sistemli yapı sayesinde hata payı minimuma indirilir.
            </p>
          </div>
        </div>
      </section>

      {/* Visa Calculator Section */}
      <VisaCalculator />

      {/* Why Us Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl text-darkBlue mb-3 sm:mb-4">
              Neden izmirvizedanismanlik.net Tercih Edilmeli?
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-6 sm:mb-8">
            <div className="bg-white rounded-xl p-4 sm:p-6 shadow-md hover:shadow-lg transition-shadow border-2 border-gray-100">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-secondary/10 rounded-full flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-award-line text-secondary text-xl sm:text-2xl"></i>
              </div>
              <h3 className="font-heading font-bold text-base sm:text-lg text-darkBlue mb-2">%98'e varan başarı oranı</h3>
            </div>

            <div className="bg-white rounded-xl p-4 sm:p-6 shadow-md hover:shadow-lg transition-shadow border-2 border-gray-100">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-secondary/10 rounded-full flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-time-line text-secondary text-xl sm:text-2xl"></i>
              </div>
              <h3 className="font-heading font-bold text-base sm:text-lg text-darkBlue mb-2">10+ yıl sektör deneyimi</h3>
            </div>

            <div className="bg-white rounded-xl p-4 sm:p-6 shadow-md hover:shadow-lg transition-shadow border-2 border-gray-100">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-secondary/10 rounded-full flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-shield-check-line text-secondary text-xl sm:text-2xl"></i>
              </div>
              <h3 className="font-heading font-bold text-base sm:text-lg text-darkBlue mb-2">İade garantili danışmanlık modeli</h3>
            </div>

            <div className="bg-white rounded-xl p-4 sm:p-6 shadow-md hover:shadow-lg transition-shadow border-2 border-gray-100">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-secondary/10 rounded-full flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-book-open-line text-secondary text-xl sm:text-2xl"></i>
              </div>
              <h3 className="font-heading font-bold text-base sm:text-lg text-darkBlue mb-2">Güncel mevzuata hakim uzman ekip</h3>
            </div>

            <div className="bg-white rounded-xl p-4 sm:p-6 shadow-md hover:shadow-lg transition-shadow border-2 border-gray-100">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-secondary/10 rounded-full flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-price-tag-3-line text-secondary text-xl sm:text-2xl"></i>
              </div>
              <h3 className="font-heading font-bold text-base sm:text-lg text-darkBlue mb-2">Şeffaf fiyatlandırma</h3>
            </div>

            <div className="bg-white rounded-xl p-4 sm:p-6 shadow-md hover:shadow-lg transition-shadow border-2 border-gray-100">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-secondary/10 rounded-full flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-user-heart-line text-secondary text-xl sm:text-2xl"></i>
              </div>
              <h3 className="font-heading font-bold text-base sm:text-lg text-darkBlue mb-2">Birebir danışman desteği</h3>
            </div>
          </div>

          <div className="max-w-3xl mx-auto text-center">
            <p className="font-body text-gray-600">
              Amacımız sadece başvuru almak değil, doğru başvuruyu yapmak.
            </p>
          </div>
        </div>
      </section>

      {/* Additional Content Sections */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-b from-lightBlue to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
          {/* İzmir'in En İyi */}
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading font-bold text-3xl lg:text-4xl text-darkBlue mb-6 text-center">
              İzmir'in En İyi Vize Danışmanlık Şirketi ile Çalışın
            </h2>
            <p className="font-body text-lg text-gray-600 leading-relaxed mb-4">
              İzmir'de vize danışmanlık firması seçerken tecrübe ve süreç yönetimi büyük önem taşır. izmirvizedanismanlik.net, her başvuruyu standart bir işlem olarak değil, danışana özel bir süreç olarak ele alır.
            </p>
            <p className="font-body text-lg text-gray-600 leading-relaxed">
              Bu yaklaşım, yüksek onay oranlarının en önemli nedenidir.
            </p>
          </div>

          {/* Yunanistan Kosmos */}
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading font-bold text-3xl lg:text-4xl text-darkBlue mb-6 text-center">
              Yunanistan – Kosmos Vize Başvurusu Nasıl Yapılır?
            </h2>
            <p className="font-body text-lg text-gray-600 leading-relaxed">
              Yunanistan Schengen vize başvuruları İzmir'de Kosmos Vize aracılığıyla yapılmaktadır. Randevu planlaması, evrak hazırlığı ve başvuru süreci profesyonel destek olmadan risk oluşturabilir. Danışmanlarımız, Kosmos Vize prosedürlerine uygun şekilde başvurunuzu hazırlar ve süreci sizin adınıza takip eder.
            </p>
          </div>

          {/* Schengen 2026 */}
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading font-bold text-3xl lg:text-4xl text-darkBlue mb-6 text-center">
              İzmir Schengen Vize Alma Adımları (2026)
            </h2>
            <p className="font-body text-lg text-gray-600 leading-relaxed mb-6">
              2026 yılı itibarıyla Schengen vize başvuru süreçleri daha detaylı inceleme içermektedir:
            </p>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-fill text-secondary text-xl mt-1"></i>
                <span className="font-body text-gray-600">Güncel finansal belgeler</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-fill text-secondary text-xl mt-1"></i>
                <span className="font-body text-gray-600">Seyahat amacına uygun evraklar</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-fill text-secondary text-xl mt-1"></i>
                <span className="font-body text-gray-600">Güçlü geri dönüş bağları</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-fill text-secondary text-xl mt-1"></i>
                <span className="font-body text-gray-600">Doğru ve tutarlı başvuru dosyası</span>
              </li>
            </ul>
            <p className="font-body text-lg text-gray-600 leading-relaxed mt-6">
              izmirvizedanismanlik.net, bu kriterlere uygun başvurular hazırlanmasını sağlar.
            </p>
          </div>
        </div>
      </section>

      {/* Countries Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl text-darkBlue mb-4">
              İzmir Vize Danışmanlık Hangi Ülkelere Hizmet Verir?
            </h2>
            <p className="font-body text-base sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed mb-6">
              <strong>İzmir vize danışmanlık</strong> hizmetlerimiz kapsamında Schengen vizesi başta olmak üzere birçok ülkeye yönelik profesyonel <strong>vize başvurusu</strong> desteği sunuyoruz. Uzman kadromuz, her ülkenin güncel vize gereksinimlerini takip ederek başvurularınızı eksiksiz ve doğru şekilde hazırlar.
            </p>
            <h3 className="font-heading font-bold text-xl sm:text-2xl text-darkBlue mb-6">
              Vize Verdiğimiz Ülkeler
            </h3>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4 mt-8 sm:mt-12">
            {countries.map((country, index) => (
              <Link
                key={index}
                to={country.link}
                className="bg-white rounded-lg sm:rounded-xl p-4 sm:p-6 shadow-md hover:shadow-lg hover:border-secondary border-2 border-transparent transition-all duration-300 hover:scale-105 text-center group"
              >
                <div className="text-3xl sm:text-4xl lg:text-5xl mb-2 sm:mb-3">{country.flag}</div>
                <h4 className="font-heading font-bold text-sm sm:text-base text-darkBlue mb-1 sm:mb-2">{country.name}</h4>
                <p className="font-body text-xs text-gray-600 mb-2 sm:mb-3">Vize Başvurusu</p>
                <div className="flex items-center justify-center text-secondary font-semibold">
                  <span className="font-body text-xs sm:text-sm">İncele</span>
                  <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform text-sm"></i>
                </div>
              </Link>
            ))}
          </div>

          <div className="text-center mt-6 sm:mt-8">
            <Link
              to="/ulkeler"
              className="inline-flex items-center space-x-2 bg-white hover:bg-gray-50 text-secondary border-2 border-secondary px-5 sm:px-6 py-2.5 sm:py-3 rounded-full font-body font-semibold text-sm sm:text-base transition-all whitespace-nowrap"
            >
              <span>Tüm Ülkeleri Gör</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-b from-lightBlue to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading font-bold text-3xl lg:text-4xl text-darkBlue mb-6 text-center">
            İzmir Vize Danışmanlık ve Başvuru Fiyatları (2026)
          </h2>
          <p className="font-body text-lg text-gray-600 leading-relaxed text-center">
            Vize danışmanlık ücretleri; başvurulan ülke, vize türü ve evrak kapsamına göre değişiklik göstermektedir. izmirvizedanismanlik.net, 2026 yılı için şeffaf ve rekabetçi fiyat politikası uygular.
          </p>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-darkBlue text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <svg className="w-full h-full" viewBox="0 0 1200 400">
            <circle cx="200" cy="100" r="80" stroke="currentColor" strokeWidth="1" fill="none" />
            <circle cx="1000" cy="300" r="100" stroke="currentColor" strokeWidth="1" fill="none" />
          </svg>
        </div>

        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl mb-4">Müşterilerimiz Ne Diyor?</h2>
            <div className="flex items-center justify-center space-x-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-400 text-lg sm:text-xl"></i>
              ))}
            </div>
          </div>

          <div className="bg-white/95 rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-12 shadow-2xl">
            <div className="flex items-start justify-between mb-4 sm:mb-6">
              <div className="inline-flex items-center space-x-2 bg-secondary px-3 sm:px-4 py-2 rounded-full">
                <i className="ri-star-fill text-white text-sm sm:text-base"></i>
                <span className="font-heading font-bold text-white text-sm sm:text-base">
                  {testimonials[currentTestimonial].rating}.0
                </span>
              </div>
            </div>

            <blockquote className="font-body text-base sm:text-lg lg:text-xl text-gray-700 italic mb-6 sm:mb-8 leading-relaxed">
              "{testimonials[currentTestimonial].comment}"
            </blockquote>

            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3 sm:space-x-4">
                <div>
                  <div className="font-heading font-bold text-darkBlue text-base sm:text-lg">
                    {testimonials[currentTestimonial].name}
                  </div>
                  <div className="font-body text-xs sm:text-sm text-gray-600">
                    {testimonials[currentTestimonial].service}
                  </div>
                </div>
              </div>

              <div className="flex space-x-2">
                <button
                  onClick={() =>
                    setCurrentTestimonial((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1))
                  }
                  className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full border-2 border-gray-300 hover:border-secondary hover:bg-secondary hover:text-white transition-all"
                  aria-label="Önceki yorum"
                >
                  <i className="ri-arrow-left-line text-sm sm:text-base"></i>
                </button>
                <button
                  onClick={() =>
                    setCurrentTestimonial((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1))
                  }
                  className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full bg-secondary text-white hover:bg-secondary/90 transition-all"
                  aria-label="Sonraki yorum"
                >
                  <i className="ri-arrow-right-line text-sm sm:text-base"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-b from-white to-lightBlue">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-5 gap-12">
            {/* Left Content */}
            <div className="lg:col-span-2 space-y-6">
              <h2 className="font-heading font-bold text-3xl lg:text-4xl text-darkBlue">
                Sıkça Sorulan Sorular
              </h2>
              <p className="font-body text-lg text-gray-600">
                İzmir vize başvurusu hakkında merak ettikleriniz. Daha fazla bilgi için bizimle iletişime geçin.
              </p>
              <Link
                to="/sss"
                className="inline-flex items-center space-x-2 bg-secondary hover:bg-secondary/90 text-white px-6 py-3 rounded-full font-body font-semibold transition-all whitespace-nowrap"
              >
                <span>Tüm SSS'leri Gör</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            {/* Right Accordion */}
            <div className="lg:col-span-3 space-y-4">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300"
                >
                  <button
                    onClick={() => setOpenFaq(openFaq === index ? null : index)}
                    className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors"
                  >
                    <h4 className="font-heading font-bold text-darkBlue pr-4">{faq.question}</h4>
                    <i
                      className={`text-secondary text-xl transition-transform ${
                        openFaq === index ? 'ri-subtract-line' : 'ri-add-line'
                      }`}
                    ></i>
                  </button>
                  {openFaq === index && (
                    <div className="px-6 pb-6 bg-gray-50">
                      <p className="font-body text-gray-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-r from-secondary via-orange-500 to-secondary/90 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <svg className="w-full h-full" viewBox="0 0 1200 300">
            <circle cx="100" cy="150" r="100" fill="white" />
            <circle cx="1100" cy="150" r="150" fill="white" />
          </svg>
        </div>

        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl text-white mb-3 sm:mb-4">
            Vize Başvurunuza Hemen Başlayın
          </h2>
          <p className="font-body text-sm sm:text-base lg:text-lg text-white/90 mb-6 sm:mb-8">
            Ücretsiz ön değerlendirme için formu doldurun, size en kısa sürede dönüş yapalım
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <div className="flex items-center space-x-2 sm:space-x-3 bg-white/20 backdrop-blur-sm px-4 sm:px-6 py-2.5 sm:py-3 rounded-full">
              <div className="w-8 h-8 sm:w-10 sm:h-10 bg-white rounded-full flex items-center justify-center">
                <i className="ri-phone-line text-secondary text-lg sm:text-xl"></i>
              </div>
              <a
                href="tel:+905422671171"
                className="font-heading font-bold text-white text-sm sm:text-base lg:text-lg whitespace-nowrap"
              >
                +90 542 267 11 71
              </a>
            </div>
            <Link
              to="/iletisim"
              className="bg-white hover:bg-gray-100 text-secondary px-6 py-3 rounded-full font-body font-bold transition-all shadow-lg hover:shadow-xl flex items-center space-x-2 whitespace-nowrap"
            >
              <span>Formu Doldur</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
